export function formatPrice(price?: number) {
  if (!price) return

  return new Intl.NumberFormat('en-EN', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(price)
}
